import React from 'react'
import { useSelector } from 'react-redux'
import { CustomThemeProvider, styledTheme as _styledTheme } from 'heliocor-ui'
import MUITheme from './styles/MUITheme'


const CustomThemeWrapper = ({ children }) => {

    const customColors = useSelector(store => store.settings.colors || {})

    const styledTheme = {
        ..._styledTheme,
        colors: {
            ..._styledTheme.colors,
            main: customColors.mainColor || _styledTheme.colors.main,
            mainText: customColors.mainText || _styledTheme.colors.black,
            stepperBackground: customColors.stepperBackground || _styledTheme.colors.grey700,
            secondaryColor: customColors.secondaryColor || _styledTheme.colors.aqua100
        },
        buttons: {
            ..._styledTheme.buttons,
            backgroundColor: {
                ..._styledTheme.buttons.backgroundColor,
                'default': customColors.mainColor || _styledTheme.colors.main,
                'light-hover': customColors.mainColor ? `${customColors.mainColor}4c` : _styledTheme.colors.main400,
            },
            color: {
                ..._styledTheme.buttons.color,
                'light': customColors.mainColor || _styledTheme.colors.main,
                'white': customColors.mainColor || _styledTheme.colors.main,
            }
        }
    }

    return (
        <CustomThemeProvider
            theme={MUITheme(customColors)}
            styledTheme={styledTheme}
        >
            {children}
        </CustomThemeProvider>
    )
};

export default CustomThemeWrapper
